export const scrollToSection = (targetElement) => {
  const isMobile = window.screen.width < 1024
  const targetOffset = targetElement.offsetTop + (isMobile ? 60 : -20);

  const scrollOffset = window.pageYOffset;

  const distance = targetOffset - scrollOffset;
  const duration = 200;
  let startTime = null;


  if (Math.abs(distance) < (isMobile ? 1 : 10)) {
    return;
  }

  function scrollAnimation(timestamp) {
    if (!startTime) startTime = timestamp;

    const progress = timestamp - startTime;
    const increment = distance * (progress / duration);

    const newPosition = scrollOffset + increment;

    if ((increment > 0 && newPosition >= targetOffset) || (increment < 0 && newPosition <= targetOffset)) {
      window.scrollTo(0, targetOffset);
      return;
    }

    window.scrollTo(0, newPosition);

    requestAnimationFrame(scrollAnimation);
  }
  requestAnimationFrame(scrollAnimation);
}

export const scrollToFirstError = () => {
  const firstError = document.querySelector('[data-icon="circle-exclamation"]')
  if (!firstError) return;

  firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

export const getFirstScrollableParent = (element) => {
  let parent = element.parentElement;

  while (parent) {
    const style = getComputedStyle(parent);

    const isScrollable = /(auto|scroll|hidden)/.test(style.overflow + style.overflowY + style.overflowX);

    const hasScrollableContent =
      parent.scrollHeight > parent.clientHeight || parent.scrollWidth > parent.clientWidth;

    if (isScrollable && hasScrollableContent) {
      return parent;
    }

    parent = parent.parentElement;
  }

  return null;
}